module.exports = __webpack_public_path__ + "static/img/1-1-3.7ec11b21.jpg";